import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import styles from './AttributeList.less';

import T from './Typography';

export default React.memo(AttributeList);

const cxb = cx.bind(styles);

AttributeList.propTypes = {
  /**
   * The attributes to show
   * Each element of the list can be either an attribute (object with name/value
   * properties) OR a spacer (an object with a property named spacer with a value
   * of true). If it has all three, it will be a spacer.
   */
  attributes: PropTypes.arrayOf(
    PropTypes.shape({
      spacer: PropTypes.bool,
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};

/**
 * **Access:**
 * ```js
 * import {AttributeList} from '@iss/client-react-components'
 * ```
 * Renders a tabular attribute name/value list.
 *
 * @component
 */
function AttributeList({ attributes, className, ...props }) {
  return (
    <div className={cxb('root', className)} {...props}>
      {attributes.map(({ spacer, name: k, value: v }, i) =>
        spacer ? (
          <span className={cxb('spacer')} key={i} />
        ) : (
          <T.Small as="div" key={k} className={cxb('item')}>
            {k}
            {v && (
              <>
                : <b>{v}</b>
              </>
            )}
          </T.Small>
        )
      )}
    </div>
  );
}
